import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'usuariospipeactivos'
})
export class UsuariospipeactivosPipe implements PipeTransform {

  transform(value: any, numeroidusuariomx: string): any {
    const resultPost = [];
    console.log (value);
    

   
    for ( const post of value) {
    
      // esto la condicion es que sean unicamente usuariso de sportfishing
      if (post.role == "USER_SPORTFISHING")  {

        if (post._id == numeroidusuariomx) {
          resultPost.push (post);
        } else {
          resultPost.push (post);
        }
      
         
       

     

     
  
   }
  
 }

 return resultPost;


  }

}
